import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  employeeId: '',
  token: '',
  username: '',
  emailId: '',
  role: '',
  userKey: -1,
  userGuid: '',
  isLoggedin: false,
  isReset: false,
  sessionTimeout: 0,
  startTime: 0
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      let data = action.payload;
      state.username = data.username;
      state.employeeId = data.employeeId;
      state.token = data.token;
      state.emailId = data.emailId;
      state.role = data.role;
      state.userKey = data.userKey;
      state.userGuid = data.userGuid;
      state.isLoggedin = true;
      state.isReset = data.isReset;
      state.sessionTimeout = data.sessionTimeout;
      state.expTime = data.expTime;
    },

    logout: (state) => {
      state.username = '';
      state.employeeId = '';
      state.token = '';
      state.emailId = '';
      state.role = '';
      state.userKey = -1;
      state.userGuid = '';
      state.isLoggedin = false;
      state.isReset = false;
      state.sessionTimeout = 0;
      state.expTime = 0;
    },
  },
})

// Action creators are generated for each case reducer function
export const { login, logout } = authSlice.actions;

export default authSlice.reducer
